import { MoreVerticalOutlineIcon } from '@carboncopyco/icons';
import { ColorHex, Dropdown } from '@carboncopyco/ui';
import classNames from 'classnames';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { useState } from 'react';
import { useFocusAppService } from '../../hooks/useFocusAppService';
import { TextExtractionCapturing } from './TextExtractionCapturing';
import { TextExtractionExport } from './TextExtractionExport';
import { useTextExtraction } from './useTextExtraction';
import type { IGlobalTab } from '@carboncopyco/types/desktop';

export const TextExtraction = ({ tab }: { tab: IGlobalTab }) => {
  const flags = useFlags();
  const { triggerFocus } = useFocusAppService();

  const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false);
  const {
    isTextExtractionStarted,
    startTextExtraction,
    stopTextExtraction,
    downloadExtractedText,
    isCSVEmpty,
  } = useTextExtraction({ tabId: tab?.id, recording: tab?.payload?.clone });

  if (!flags.textExtraction) {
    return null;
  }

  return (
    <>
      <div className="relative flex w-8 justify-start">
        {isTextExtractionStarted && (
          <>
            <div className="bg-ds-danger-100 p-1.5 absolute right-0 top-0 rounded-full animate-pulse w-2 h-2" />
            <div
              className={classNames(
                'w-2 h-2 rounded-full m-0.5 absolute right-0 top-0 rounded-full bg-ds-danger animate-none z-2'
              )}
            />
          </>
        )}
        <Dropdown
          triggerElement={
            <MoreVerticalOutlineIcon color={ColorHex.accent3100} />
          }
          open={isMenuOpen}
          onOpenChange={(isOpen) => {
            triggerFocus(isOpen);
            setIsMenuOpen(isOpen);
          }}
          interactive
          onInteractOutside={() => setIsMenuOpen(false)}
        >
          <TextExtractionExport
            onItemClick={downloadExtractedText}
            isDisabled={isCSVEmpty}
          />
          <TextExtractionCapturing
            isTextExtractionStarted={isTextExtractionStarted}
            onTextExtractionItemClick={(isSelected) => {
              if (isSelected) {
                startTextExtraction();
                return;
              }
              stopTextExtraction();
            }}
          />
        </Dropdown>
      </div>
    </>
  );
};
